import React, { useEffect, useState } from 'react'
import { Container, Col, Form, InputGroup, FormControl } from 'react-bootstrap'

import request from '../../request';
import Paginacion from './Paginacion';
import usePropsFilter from '../hooks/usePropsFilter';
import useData from '../hooks/useData';
import Filter from './Filter';
import FilterQuery from './FilterQuery';
import Notify from './Notify';
import ComboFechas from './ComboFechas';
import nameExcel from './nameExcel';
import DescargarExcel from './DescargarExcel';
import DescargarExcelLarge from './DescargaExcelLarge'
import TablaScroll from './TablaScroll';
import BotonConsultar from './BotonConsultar';
import Loader from './Loader';
import HeaderVista from './HeaderVista'
import MultiFilterQuery from './MultiFilterQuery';
import download from "downloadjs"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFileExcel } from '@fortawesome/free-solid-svg-icons';


/**
 * Vista simple con modulo de fechas, filtrado, excel y boton de consulta
 * 
 * @param   {string}        titulo              Titulo de la vista
 * @param   {string}        route               Ruta de la consulta
 * @param   {string}        ipserv              Ip activa
 * @param   {Array}         columnasFilter     Columnas que se pueden filtrar (si no se envia no hay filtrado)
 * @param   {Boolean}       fch                 Habilitado el filtro por fecha, true por default
 * @param   {Boolean}       excel               Habilitada la descarga de excel, true por default
 * @param   {Array}         sucs                Array de seleccion ({ label, value }) que envia el parametro "suc" en la llamada, si se deja vacio no se mostrara el select
 * @param   {Array}         info                Array de strings con informacion para el usuario que use la vista
 * @param   {string}        nameExcel           Nombre del archivo excel
 * @param   {number}        QueId               AutQId de tabla cr_autq, undefined por default
 * 
 * Nota: Si QueId esta definido, la vista maneja las siguientes variables para las consultas en db:
 * 
 * @FCHDSD  {DATE}          fchdsd
 * @FCHHST  {DATE}          fchhst
 * @SUC     {INT}           suc
 */
export default function TemplateVistaSimple(props) {
    const [datasat, setDataSat] = useState([]);
    const [datasatPage, setDataSatPage] = useState([]);
    const [datasuc, setDataSuc] = useState('');

    const [page, setPage] = useState(1)

    const [fchdsd, setfchdsd] = useState('');
    const [fchhst, setfchhst] = useState('');

    const [normal, setNormal] = useState(false);
    const [crudo, setCrudo] = useState(false);
    const [checkedvalue, setChekedValue] = useState(false);

    const [propsFilter, setPropsFilter] = usePropsFilter()
    const [multiFiltros, setMultiFiltros] = useState([])
    const [tokenExcel, setTokenExcel] = useState('')

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    const rows = 50

    const [colQuery, setColQuery] = useState('')
    const [value, setValue] = useState('')

    const [filtros, setFiltros] = useData()

    const columnas = props.columnasFilter
    const col = props.colQuery

    const getdata = async () => {
        setLoading(true)
        setError(false)
        setDataSat([])
        setDataSatPage([])
        const filterQuery = colQuery ? colQuery.split(",") : []
        const filterValue = value

        let method = ''
        const url = props.ipserv + props.route + '/'
        const item = {
            ...filtros,
            fchdsd,
            fchhst,
            suc: datasuc === 'all' ? '' : datasuc
        }

        let body = {
            tokenExcel,
            propsFilter: JSON.stringify(propsFilter),
            multiFiltros: JSON.stringify(multiFiltros),
            filterQuery,
            filterValue,
            checkedvalue
        }

        console.log({ body })

        if (props.QueId) {
            body = {
                ...body,
                item,
                AutQId: props.QueId,
                ExcelLarge: props.largedata
            }

            method = 'Post'
        } else {
            Object.keys(item).forEach(k => body[k] = item[k])
            method = 'Get'
        }

        if (props.directexcel) {


            request[method](url, body, r => {
                if (r.rows === 'No data' || r.rows === 'No Data' ) r.rows = []

                setLoading(false)
                setError(false)
                download(r, props.nameExcel + datasuc + ".xlsx");
            }, 'blob', e => {
                console.log(e)
                setLoading(false)
                setError(true)
            })

        } else {

            request[method](url, body, r => {
                if (r.rows === 'No data' || r.rows === 'No Data') r.rows = []

                if (r.rows.length === 0) Notify({ type: 'busqueda_fail' })
                if (r.msg) Notify({ type: 'info', text: r.msg })
                setDataSat(r.rows);
                setDataSatPage(r.rows.slice(0, rows));
                setPage(1)
                setTokenExcel(r.tokenExcel)
                setLoading(false)
                setError(false)
            }, 'json', e => {
                console.log(e)
                setLoading(false)
                setError(true)
            })
        }
    }

    const onChangePage = (list, p) => {
        setDataSatPage(list)
        setPage(p)
    }

    const search = () => {
        let cond

        if (props.sucs && (props.fch === undefined || props.fch)) {
            cond = !fchdsd || !fchhst || (!datasuc && datasuc !== 0)
        } else if (!props.sucs && (props.fch === undefined || props.fch)) {
            cond = !fchdsd || !fchhst
        } else if (props.sucs && !props.fch) {
            cond = (!datasuc && datasuc !== 0)
        } else {
            cond = false
        }

        if (props.filtros) {
            const keysFiltros = Object.keys(filtros)

            keysFiltros.forEach(k => {
                const filtro = props.filtros.filter(f => f.key === k)[0]
                const v = filtros[k]

                console.log({ filtro, v, k })
                console.log(!v)
                console.log(filtro.required)

                if (!v && filtro.required) cond = true
            })
        }

        if (cond) {
            Notify({ type: 'completar' })
            return
        }

        getdata();
    }

    const selecsuc = e => {
        setDataSat([]);
        setDataSuc(e.target.value);
    };

    const selectcheck = (tipo) => {
        if (tipo === "normal") {
            setNormal(true)
            setCrudo(false)
        } else {
            setNormal(false)
            setCrudo(true)
        }

        setChekedValue(tipo)
    }

    useEffect(() => {
        if (props.filtros) {
            let f = {}

            props.filtros.forEach(item => f[item.key] = '')

            setFiltros(f)
        }
    }, [])

    useEffect(() => {
        if (props.sucs && props.sucs.length > 0) {
            const id = props.sucs[0].value
            setDataSuc(id)
        }
    }, [JSON.stringify(props.sucs || [])])

    return <div className="sa-panel animate__animated animate__fadeIn">
        <div className="sa-panel-header">
            <h3 className="sa-panel-title">
                <FontAwesomeIcon icon={faSearch} className="mr-2" style={{ color: 'var(--sa-primary)' }} />
                {props.titulo}
            </h3>
        </div>

        <div className="sa-panel-body">
            <Form className="d-flex flex-wrap align-items-center gap-3">
                {(props.fch === undefined || props.fch) &&
                    <ComboFechas
                        idFormDesde={"form-dsd-" + props.idForm}
                        idFormHasta={"form-hst-" + props.idForm}
                        defaultComboMes={0}
                        soloFchDsd={props.soloFchDsd}
                        setFechDesde={setfchdsd}
                        setFechHasta={setfchhst}
                    />
                }

                {props.sucs &&
                    <Form.Control
                        className="sa-input"
                        style={{ width: '240px' }}
                        onChange={e => selecsuc(e)}
                        as="select"
                        defaultValue=""
                    >
                        {props.sucs.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </Form.Control>
                }



                {props.radio && <Form >
                    <div >
                        <div >Seleccione Tipo de Reporte a Descargar   :</div>
                        <div className='d-flex'>
                            <Form.Check onChange={(e) => selectcheck("normal")}
                                className='p-2'
                                type={"checkbox"}
                                id={`default-radio`}
                                label={<h6> Normal </h6>}
                                checked={normal}

                            />
                            <Form.Check onChange={(e) => selectcheck("crudo")}
                                checked={crudo}
                                type={"checkbox"}
                                label={<h6> Crudo </h6>}
                                id={`disabled-default-radio`}

                            />
                        </div>
                    </div>
                </Form>}

                <BotonConsultar
                    className="sa-btn sa-btn-primary"
                    disabled={loading}
                    loading={loading}
                    search={search}
                />

                {(props.excel === undefined || props.excel) &&
                    <DescargarExcel
                        className="sa-btn sa-btn-success"
                        disabled={datasat.length === 0 || loading}
                        route={props.route}
                        ipserv={props.ipserv}
                        tokenExcel={tokenExcel}
                        titulo={props.titulo}
                        nombreExcel={nameExcel(props.nameExcel, { dsd: fchdsd, hst: fchhst })}
                    />
                }

                {
                    (props.largedata) &&
                    < DescargarExcelLarge
                        className="sa-btn sa-btn-amber"
                        ipserv={props.ipserv}
                        disabled={datasat.length === 0 && props.largedata == false || loading}
                        dataExcel={datasat}
                        nombreExcel={nameExcel(props.titulo, { dsd: fchdsd, hst: fchhst })}
                        tipo={checkedvalue}
                        groupField={props.groupField}
                        encabezado={props.encabezado}
                        AutQId={props.QueId}
                        largedata={props.largedata}
                    />
                }
            </Form>

            {(props.fch === undefined || props.fch) &&
                <div className="sa-page-info mt-2" style={{ color: '#94a3b8' }}>
                    <FontAwesomeIcon icon={faSearch} className="mr-1" style={{ fontSize: '0.7rem' }} />
                    Para buscar información, selecciona una Fecha Desde {!props.soloFchDsd && "y una Fecha Hasta."}
                </div>
            }

            {props.largedata && (
                <div className="sa-alert sa-alert-warning mt-3">
                    <FontAwesomeIcon icon={faSearch} />
                    <div>
                        <p className="mb-1"><strong>Soporte de Grandes Volúmenes</strong></p>
                        <p className="mb-0 opacity-75" style={{ fontSize: '0.8rem' }}>Este reporte soporta descarga directa de hasta 1.048.576 filas. Si el resultado es superior a 400.000 registros, usa la descarga directa para evitar errores.</p>
                    </div>
                </div>
            )}

            {props.columnasFilter &&
                <div className='mt-2' style={{ width: '60%' }}>
                    {props.multiCol
                        ? <MultiFilterQuery
                            columnas={columnas}
                            accion={search}
                            setFiltros={setMultiFiltros}
                        />
                        : <Filter
                            columnas={columnas}
                            setProps={setPropsFilter}
                            accion={search}
                        />
                    }
                </div>
            }


            {props.colQuery &&
                <div className='mt-2' style={{ width: '60%' }}>
                    <FilterQuery
                        col={col}
                        acction={search}
                        setDataQuery={setColQuery}
                        setValues={setValue}
                    />
                </div>
            }

            {(props.filtros || []).sort((a, b) => a.required ? -1 : 1).map(f => (
                <InputGroup className="my-3 half-width ml-2" key={f.label + f.key}>
                    <InputGroup.Text>{f.label}</InputGroup.Text>
                    {f.tipo === 'select' ? (
                        <Form.Control
                            as="select"
                            name={f.key}
                            defaultValue={f.defaultValue || ''}
                            onChange={setFiltros}
                        >
                            {!f.hideEmptyOption && (
                                <option value="">
                                    {f.placeholder || 'Seleccione una opción'}
                                </option>
                            )}

                            {(f.options || []).map(op => (
                                <option key={op.value} value={op.value}>
                                    {op.label}
                                </option>
                            ))}
                        </Form.Control>
                    ) : (
                        <FormControl
                            type={f.tipo || 'text'}
                            placeholder={f.placeholder || 'Buscar'}
                            name={f.key}
                            input="true"
                            onChange={setFiltros}
                        />
                    )}

                    {f.required && (
                        <div className='ml-2 d-flex align-items-center text-negative'>
                            *Requerido
                        </div>
                    )}
                </InputGroup>
            ))}

            <div className="mt-4">
                <Loader loading={loading} error={error}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="sa-page-info">
                            Mostrando {datasatPage.length} de {datasat.length} registros
                        </div>
                        {datasat.length > 0 &&
                            <Paginacion
                                page={page}
                                rows={rows}
                                data={datasat}
                                onChangePage={onChangePage}
                            />
                        }
                    </div>

                    <div className="sa-table-container">
                        <TablaScroll
                            columnas={Object.keys(datasatPage[0] || {})}
                            data={datasatPage}
                        />
                    </div>

                    {datasat.length > 0 &&
                        <div className='d-flex justify-content-center mt-4'>
                            <Paginacion
                                page={page}
                                rows={rows}
                                data={datasat}
                                onChangePage={onChangePage}
                            />
                        </div>
                    }
                </Loader>
            </div>
        </div>
    </div>
}
